import { Select } from "components/shared/form";
import SelectMenuActionButton from "components/shared/selectMenuActionButton";
import { catalogEntityOptionFlags, catalogEntityOptionFlagsEnum } from "helpers/enums";
import { flagVal } from "helpers/system";
import policy from "policies";
import React, { useEffect, useState } from "react";
import { components } from "react-select";
import { catalogItemsList, getCatalogInfo } from "sources/books/dictionaries";

const hiddenFlagVal = flagVal(catalogEntityOptionFlags, catalogEntityOptionFlagsEnum.Invisible);
const requiredFlagVal = flagVal(catalogEntityOptionFlags, catalogEntityOptionFlagsEnum.Required);
const showInEmptyMileageBidsFlagVal = flagVal(
    catalogEntityOptionFlags,
    catalogEntityOptionFlagsEnum.ShowInEmptyMileageBids,
);

const canEditCatalogItems = ({ canEditBooks, roles }) => {
    const canEdit = typeof canEditBooks === "function" ? canEditBooks() : !!canEditBooks;
    if (!canEdit || !roles) {
        return false;
    }
    return policy("path", {
        user: { roles },
        record: {},
        options: {},
    }).canSeeOrganizationCatalogs();
};

const CatalogItemMenuList = (props) => {
    const {
        children,
        selectProps: { canCreateCatalogItem, catalogInfo, modal, onCreateCatalogItem },
    } = props;

    const handleCreateItem = () => {
        if (!modal || !catalogInfo?.id) {
            return;
        }
        modal({
            name: "organizationCatalogItemForm",
            title: "Создание элемента справочника",
            data: { catalogId: catalogInfo.id },
            dictionary: catalogInfo,
            onSuccess: (item) => {
                if (item?.id) {
                    onCreateCatalogItem(item);
                }
            },
        });
    };

    return (
        <>
            <components.MenuList {...props}>{children}</components.MenuList>
            {canCreateCatalogItem && (
                <div className="text-center border-top">
                    <SelectMenuActionButton onAction={handleCreateItem}>
                        Добавить новый пункт справочника
                    </SelectMenuActionButton>
                </div>
            )}
        </>
    );
};

const TypeOptionSelect = (props) => {
    const { option, setValue, typeOptionsValue, i, checkBidRelation, modal, roles, canEditBooks } = props;
    const [catalogInfo, setCatalogInfo] = useState({});
    const isHiddenByRelation = checkBidRelation && (option.intRelationFlags & hiddenFlagVal) === hiddenFlagVal;

    useEffect(() => {
        if (isHiddenByRelation) {
            return;
        }
        getCatalogInfo(option.catalogPropertyName).then((data) => setCatalogInfo(data || {}));
    }, [option.catalogPropertyName, isHiddenByRelation]);

    if (isHiddenByRelation) {
        return null;
    }

    const intFlags = checkBidRelation ? option.intRelationFlags : option.intFlags;
    const isRequired = (intFlags & requiredFlagVal) === requiredFlagVal;
    const typeOptionIndex = typeOptionsValue.findIndex((x) => x.entityOptionId === option.entityOptionId);
    const setItemValue = ({ name, value }) => {
        const newValue = [...typeOptionsValue];
        if (value) {
            const newOptionValue = { entityOptionId: option.entityOptionId, id: value };
            typeOptionIndex !== -1
                ? newValue.splice(typeOptionIndex, 1, newOptionValue)
                : newValue.push(newOptionValue);
        } else {
            newValue.splice(typeOptionIndex, 1);
        }
        return setValue({ name, value: newValue });
    };
    const value = typeOptionIndex !== -1 ? typeOptionsValue[typeOptionIndex].id : null;
    const catalogFilter = { externalId: option.catalogPropertyName };
    const filter = value ? { or: [{ id: value }, catalogFilter] } : catalogFilter;
    const canCreateCatalogItem = !!catalogInfo.id && !!modal && canEditCatalogItems({ canEditBooks, roles });
    const onCreateCatalogItem = (item) => setItemValue({ name: "typeOptions", value: item.id });

    return (
        <Select
            required={isRequired}
            wrapper="book-field"
            fieldWrapper="col-sm-8 col-md-5"
            inputProps={{
                name: "typeOptions",
            }}
            propName="displayName"
            url={(props) => catalogItemsList({ filter, ...props })}
            onChange={setItemValue}
            value={value}
            index={i}
            tooltip={catalogInfo.description}
            label={option.displayName}
            order={option.order}
            modal={modal}
            catalogInfo={catalogInfo}
            canCreateCatalogItem={canCreateCatalogItem}
            onCreateCatalogItem={onCreateCatalogItem}
            components={{ MenuList: CatalogItemMenuList }}
        />
    );
};

const TypeOptions = ({
    setValue,
    entityType,
    typeOptionsValue,
    entityOptions,
    checkBidRelation,
    isEmptyMileageBid,
    showAllInEmptyMileageBid,
    modal,
    roles,
    canEditBooks,
}) => {
    return entityOptions
        .filter((x) => {
            const intFlags = checkBidRelation ? x.intRelationFlags : x.intFlags;
            const isShownInEmptyMileageBid =
                x.showInEmptyMileageBids ||
                (showInEmptyMileageBidsFlagVal > 0 &&
                    (intFlags & showInEmptyMileageBidsFlagVal) === showInEmptyMileageBidsFlagVal);
            return (
                x.entityType === entityType &&
                !!x.catalogPropertyName &&
                (intFlags & hiddenFlagVal) !== hiddenFlagVal &&
                (!isEmptyMileageBid || showAllInEmptyMileageBid || isShownInEmptyMileageBid)
            );
        })
        .map((option, i) => (
            <TypeOptionSelect
                key={i}
                option={option}
                setValue={setValue}
                checkBidRelation={checkBidRelation}
                typeOptionsValue={typeOptionsValue}
                i={i}
                modal={modal}
                roles={roles}
                canEditBooks={canEditBooks}
            />
        ));
};

export default TypeOptions;
